export default "/images/vendor/flag-icons/flags/4x3/bo.svg?51e0ec28072b3d8c605fe5709c1ee322";